import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Anchor, xcss } from '@atlaskit/primitives';

const anchorStyles = xcss({
	display: 'inline-block',
	overflow: 'hidden',
	font: 'font.body',
	color: 'color.text.subtlest',
	textDecoration: 'none',
	':hover': {
		color: 'color.text.subtlest',
	},
	':visited': {
		color: 'color.text.subtlest',
	},
	':focus': {
		color: 'color.text.subtlest',
	},
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
});

const SearchMetadataLink = ({
	label,
	href,
}: {
	label: string;
	href: string;
}): React.JSX.Element => {
	return (
		<Anchor href={href} xcss={anchorStyles} testId="search-page-result-metadata-link">
			{label}
		</Anchor>
	);
};

export default SearchMetadataLink;
